//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 07/10/2025
// Version       : 1
// Description   : Tabla de tipos de vehiculos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../../../../services/apirest";
import { MaterialReactTable } from "material-react-table";
// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Box,
  Dialog,
  Typography,
  IconButton,
  Button,
  ThemeProvider,
  createTheme,
  useTheme,
  Tooltip,
} from "@mui/material";
// COMPONENTES
import AgregarRelacion from "./AgregarRelacion";
import CambiarEstadoRelacion from "./CambiarEstadoRelacion";

// ICONOS
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BlockIcon from "@mui/icons-material/Block";

function RelacionTipoVehiculoComponentes(props) {
  const globalTheme = useTheme();

  const [relaciones, setRelaciones] = useState([]);
  const [row, setRow] = useState(props.row);
  const [relacionSeleccionada, setRelacionSeleccionada] = useState([]);

  //*************************************************************************************************************************************/

  const obtenerRelaciones = () => {
    fetch(UrlApi + "/relacion_tiposv_componentes/" + row.id)
      .then((data) => data.json())
      .then((data) => setRelaciones(data));
  };

  useEffect(() => {
    obtenerRelaciones();
  }, []);

  //*************************************************************************************************************************************/

  // DIALOG PARA AGREGAR RELACIÓN
  const [dialogAgregar, setDialogAgregar] = useState(false);

  // Abrir diálogo para agregar relación
  const handleOpenAgregarRelacion = () => {
    setDialogAgregar(true);
  };

  // Cerrar diálogo
  const handleCloseAgregarRelacion = () => {
    setDialogAgregar(false);
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA CAMBIAR ESTADO DE LAS PRODUCTOS
  const [openCambiarEstadoRelacion, setOpenCambiarEstadoRelacion] =
    useState(false);

  const handleOpenCambiarEstadoRelacion = (row) => {
    setRelacionSeleccionada(row);
    setOpenCambiarEstadoRelacion(true);
  };

  const handleCloseCambiarEstadoRelacion = () => {
    setOpenCambiarEstadoRelacion(false);
  };

  //*************************************************************************************************************************************/

  // ----------- TABLA ---------------
  const customLocalization = {
    ...MRT_Localization_ES,
    body: {
      ...MRT_Localization_ES.body,
      noData: "No hay registros para mostrar",
    },
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID Relación",
        size: 150,
      },
      {
        accessorKey: "componente",
        header: "Componente",
        size: 150,
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    sorting: [{ id: "componente", desc: false }],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white", // color de los íconos
      },
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default: "rgb(234, 239, 241)",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  //*************************************************************************************************************************************/

  // Función para actualizar los datos luego de que se guarde uno nuevo
  const handleRelacionGuardada = () => {
    obtenerRelaciones(); // Vuelve a obtener los datos actualizados
  };

  return (
    <>
      <Box
        sx={{
          marginBottom: "25px",
          marginLeft: "40px",
          marginRight: "40px",
        }}
      >
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            columns={columns}
            data={relaciones}
            initialState={initialState}
            positionActionsColumn="last"
            autoResetPageIndex={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableColumnActions={true}
            enableColumnFilters={false} // Desactiva filtros por columna
            enableHiding={false}
            localization={customLocalization}
            enableRowSelection={false}
            enableRowActions={true}
            enableGlobalFilter
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            muiTableBodyCellProps={({}) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "transparent",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Componentes
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  style={{ marginTop: "5px" }}
                  startIcon={<AddBoxOutlinedIcon />}
                  onClick={handleOpenAgregarRelacion}
                >
                  Agregar Relación
                </Button>
              </>
            )}
            muiTableBodyRowProps={({ table, row }) => {
              // índice de la fila
              const rowIndex = table
                .getRowModel()
                .rows.findIndex((r) => r.id === row.id);

              // Paleta
              const palettes = {
                1: {
                  // ACTIVO
                  active: ["#eafef0", "#d8fbe2"], // alternancia par/impar
                  hover: "#d1f7d6",
                },
                2: {
                  // INACTIVO
                  active: ["#fdeaea", "#fbdada"], // alternancia par/impar
                  hover: "#f8cfcf",
                },
                default: {
                  // fallback (por si el estado no es 1 ni 2)
                  active: ["#ffffff", "#fafafa"],
                  hover: "#f3f4f6",
                },
              };

              // Paleta según el estado (si no es 1 o 2, usa default)
              const estado = Number.parseInt(row.original?.estado, 10);
              const pal = palettes[estado] || palettes.default;

              // color de fondo alternado con index
              const bgColor = pal.active[rowIndex % 2];

              return {
                hover: false,
                sx: {
                  backgroundColor: bgColor,
                  color: "black",
                  borderColor: "transparent",
                  transition:
                    "background-color 0.18s ease-in-out, transform 0.15s ease",
                  // línea inferior entre celdas
                  "& .MuiTableCell-root": {
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                  },
                  // hover personalizado
                  "&:hover": {
                    backgroundColor: pal.hover,
                    transform: "translateY(-1px)",
                  },
                },
              };
            }}
            renderRowActions={({ row }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                <Tooltip
                  arrow
                  placement="left"
                  disableInteractive
                  title={
                    row.original.estado === 1
                      ? "Anular Relación"
                      : "Activar Relación"
                  }
                >
                  <IconButton
                    onClick={() =>
                      handleOpenCambiarEstadoRelacion(row.original)
                    }
                  >
                    <BlockIcon
                      sx={{
                        color: row.original.estado === 1 ? "red" : "green",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          />
        </ThemeProvider>
      </Box>

      {/* AGREGAR RELACION */}
      <Dialog
        fullWidth
        maxWidth={"sm"}
        open={dialogAgregar}
        onClose={handleCloseAgregarRelacion}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
            overflow: "hidden",
            border: "2px solid #2B76A6",
            backgroundColor: "#ffffff",
            boxSizing: "border-box",
          },
        }}
      >
        <AgregarRelacion
          handleCloseAgregarRelacion={handleCloseAgregarRelacion} // Función para cerrar el diálogo
          onRelacionGuardada={handleRelacionGuardada} // Recargar tabla al guardar
          row={row}
        />
      </Dialog>

      {/* CAMBIAR ESTADO RELACIÓN */}
      <Dialog
        open={openCambiarEstadoRelacion}
        onClose={handleCloseCambiarEstadoRelacion}
        fullWidth
        maxWidth={"xs"}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            overflow: "hidden",
          },
        }}
      >
        <CambiarEstadoRelacion
          relacion={relacionSeleccionada}
          handleCloseCambiarEstadoRelacion={handleCloseCambiarEstadoRelacion} // Función para cerrar el diálogo
          onRelacionGuardada={handleRelacionGuardada} // Recargar tabla al guardar
        />
      </Dialog>
    </>
  );
}

export default RelacionTipoVehiculoComponentes;
